// This file originally handled imports for all video clips.
// Since we now use HLS adaptive streaming (Hls.js) in video2.jsx,
// those direct imports are no longer necessary and can cause build errors.
// We keep the structure to satisfy hero3.jsx but simplify the content.

import i1 from "../media/vid/thumbnail_1.webp";
import i2 from "../media/vid/thumbnail_2.webp";
import i3 from "../media/vid/thumbnail_3.webp";
import i4 from "../media/vid/thumbnail_4.webp";
import i5 from "../media/vid/thumbnail_5.webp";
import i6 from "../media/vid/thumbnail_6.webp";
import i7 from "../media/vid/thumbnail_7.webp";

const dummy_v = ""; 

export const bgvideos = [
  [dummy_v, i1],
  [dummy_v, i2],
  [dummy_v, i3],
  [dummy_v, i4],
  [dummy_v, i5],
  [dummy_v, i6],
  [dummy_v, i7],
];

export const fullvideoURL = "https://youtu.be/p8eM7RrDK-Q";
export const localVideoTest = dummy_v;
